// extracted by mini-css-extract-plugin
export default {"title":"_1pb6","titleLeft":"_3aTt","panel":"_3wTP"};